<!-- all author pages -->
<ng-container *ngIf="model.id!='index' && model.id!='2019010209174989977'">
  <app-headerbar></app-headerbar>

  <!----- page ---------------------------------------------------->
  <ul class="master-tab nav nav-pills" id="master-tab">
    <li class="nav-item" role="presentation">
      <button class="nav-link active" id="desktop-tab" data-bs-toggle="tab" data-bs-target="#desktop" type="button" role="tab" aria-controls="desktop" aria-selected="true"><i class="bi bi-speedometer2"></i> میز
        کار</button>
    </li>
    <li class="nav-item" role="presentation">
      <button class="nav-link" id="pages-tab" data-bs-toggle="tab" data-bs-target="#pages" type="button" role="tab" aria-controls="pages" aria-selected="false">{{model.tit}} <i
          class="bi bi-x-circle"></i></button>
    </li>
  </ul>
  <br>
  <div class="container-fluid">
    <div class="tab-content" id="myTabContent">

      <!-- desktop tab page -->
      <div class="tab-pane fade show active desktop row" id="desktop" role="tabpanel" aria-labelledby="desktop-tab" style="min-height:100px; background: url(localhost:2021/filer/log_login); background-repeat: repeat;">

        <!-- <div class="pad_line"><img src=""></div> -->
        <div class="info_group">
          <div class="info_group_lay1"></div>
          <div class="info_group_lay2"></div>
          <div class="info_group_lay3"><i class="bi bi-question-lg"></i></div>
          <div class="info">
            <h5 class="title">{{glob.config.title}}</h5>
            <br>
            <table class="table table-striped table-borderless table-sm">
              <thead>
                <tr>
                  <th>نام کاربری: </th>
                  <th>{{glob.session.user_name}}</th>
                </tr>
              </thead>
              <tbody>
                <tr>
                  <td>شماره پرسنلی: </td>
                  <td>{{glob.session.no}}</td>
                </tr>
                <tr>
                  <td>نام: </td>
                  <td>{{glob.session.name + ' ' + glob.session.family}}</td>
                </tr>
                <tr>
                  <td>شرکت - شعبه: </td>
                  <td>{{glob.session.company_tit + ' - ' + glob.session.branch_tit}}</td>
                </tr>
                <tr>
                  <td>واحد - رتبه: </td>
                  <td>{{glob.session.unit_tit + ' - ' + glob.session.grade_tit}}</td>
                </tr>
                <tr>
                  <td>استان - شهرستان: </td>
                  <td>{{glob.session.province_tit + ' - ' + glob.session.city_tit}}</td>
                </tr>
                <tr>
                  <td>نشانی: </td>
                  <td>{{glob.session.address}}</td>
                </tr>
              </tbody>
            </table>

          </div>
        </div>




      </div>

      <!-- other tab page -->
      <div class="tab-pane fade" id="pages" role="tabpanel" aria-labelledby="pages-tab">

        <!-- <app-dashboard *ngIf="pageId=='admin_dashboard'"></app-dashboard> -->


        <!--******* body *********************************************************-->
        <div *ngFor="let row of layout; let irow=index;" class="row">
          <div *ngFor="let col of row; let icol=index;" class="col">
            <br>
            <!-- --- normal display  -------------------------->
            <ng-container *ngIf="col[0].dis==2 || col[0].disf==2">
              <ng-container *ngFor="let mdl of col; let i=index;">
                <app-chtm *ngIf="mdl.ctyp=='chtm'" [model]="mdl"></app-chtm>
                <!-- <app-grid *ngIf="condition_gridform(mdl, 1)" [model]="mdl"></app-grid> -->
                <!-- <app-formy *ngIf="condition_gridform(mdl, 2)" [model]="mdl"></app-formy> -->
                <app-grid *ngIf="mdl.ctyp=='grid' && mdl.dis==2" [model]="mdl"></app-grid>
                <app-formy *ngIf="mdl.ctyp=='grid' && mdl.disf==2 " [model]="mdl"></app-formy>
                <app-chart *ngIf="mdl.ctyp=='chart'" [model]="mdl"></app-chart>
                <app-treev *ngIf="mdl.ctyp=='treev'" [model]="mdl"></app-treev>
                <app-infocard *ngIf="mdl.ctyp=='infocard'" [model]="mdl"></app-infocard>
              </ng-container>
            </ng-container>

            <!----- card display --------------------------->
            <ng-container *ngIf="col[0].dis==3 || col[0].disf==3">
              <div class="card">
                <div class="card-body">
                  <ng-container *ngFor="let mdl of col; let i=index;">
                    <app-chtm *ngIf="mdl.ctyp=='chtm'" [model]="mdl"></app-chtm>
                    <!-- <app-grid *ngIf="condition_gridform(mdl, 1)" [model]="mdl"></app-grid> -->
                    <!-- <app-formy *ngIf="condition_gridform(mdl, 2)" [model]="mdl"></app-formy> -->
                    <app-grid *ngIf="mdl.ctyp=='grid' && mdl.dis==3" [model]="mdl"></app-grid>
                    <app-formy *ngIf="mdl.ctyp=='grid' && mdl.disf==3" [model]="mdl"></app-formy>
                    <app-chart *ngIf="mdl.ctyp=='chart'" [model]="mdl"></app-chart>
                    <app-treev *ngIf="mdl.ctyp=='treev'" [model]="mdl"></app-treev>
                    <app-infocard *ngIf="mdl.ctyp=='infocard'" [model]="mdl"></app-infocard>
                  </ng-container>
                </div>
              </div>
            </ng-container>

            <!----- nav display --------------------------->
            <ng-container *ngIf="col[0].dis==4 || col[0].disf==4">
              <nav>
                <div class="nav nav-tabs" id="nav-tab" role="tablist">
                  <button *ngFor="let mdl of col; let i=index" class="nav-link{{col[0]==mdl?' active':''}}" id="{{'nav-'+mdl.id+'-tab'}}" data-bs-toggle="tab" [attr.data-bs-target]="'#nav-'+mdl.id" type="button"
                    role="tab" [attr.aria-controls]="'nav-'+mdl.id" aria-selected="false">{{mdl.tit}}</button>
                </div>
              </nav>
              <div class="tab-content">
                <div id="{{'nav-'+mdl.id}}" *ngFor="let mdl of col; let i=index" class="tab-pane{{col[0]==mdl?' show active':''}}" role="tabpanel" [attr.aria-labelledby]="'nav-'+mdl.id+'-tab'">
                  <app-chtm *ngIf="mdl.ctyp=='chtm'" [model]="mdl"></app-chtm>
                  <app-grid *ngIf="mdl.ctyp=='grid' && mdl.dis==4" [model]="mdl"></app-grid>
                  <app-formy *ngIf="mdl.ctyp=='grid' && mdl.disf==4" [model]="mdl"></app-formy>
                  <app-chart *ngIf="mdl.ctyp=='chart'" [model]="mdl"></app-chart>
                  <app-treev *ngIf="mdl.ctyp=='treev'" [model]="mdl"></app-treev>
                  <app-infocard *ngIf="mdl.ctyp=='infocard'" [model]="mdl"></app-infocard>
                </div>
              </div>
            </ng-container>
          </div>
        </div>
      </div>
    </div>
  </div>

</ng-container>














<!--****** base page *********************************************************-->

<ng-container *ngIf="model.id=='index' || model.id=='2019010209174989977'">
  <div *ngFor="let row of layout; let irow=index;" class="row">
    <div *ngFor="let col of row; let icol=index;" class="col">
      <br>
      <!-- --- normal display  -------------------------->
      <ng-container *ngIf="col[0].dis==2 || col[0].disf==2">
        <ng-container *ngFor="let mdl of col; let i=index;">
          <app-chtm *ngIf="mdl.ctyp=='chtm'" [model]="mdl"></app-chtm>
          <!-- <app-grid *ngIf="condition_gridform(mdl, 1)" [model]="mdl"></app-grid> -->
          <!-- <app-formy *ngIf="condition_gridform(mdl, 2)" [model]="mdl"></app-formy> -->
          <app-grid *ngIf="mdl.ctyp=='grid' && mdl.dis==2" [model]="mdl"></app-grid>
          <app-formy *ngIf="mdl.ctyp=='grid' && mdl.disf==2" [model]="mdl"></app-formy>
          <app-chart *ngIf="mdl.ctyp=='chart'" [model]="mdl"></app-chart>
          <app-treev *ngIf="mdl.ctyp=='treev'" [model]="mdl"></app-treev>
        </ng-container>
      </ng-container>

      <!----- card display --------------------------->
      <ng-container *ngIf="col[0].dis==3 || col[0].disf==3">
        <div class="card">
          <div class="card-body">
            <ng-container *ngFor="let mdl of col; let i=index;">
              <app-chtm *ngIf="mdl.ctyp=='chtm'" [model]="mdl"></app-chtm>
              <!-- <app-grid *ngIf="condition_gridform(mdl, 1)" [model]="mdl"></app-grid> -->
              <!-- <app-formy *ngIf="condition_gridform(mdl, 2)" [model]="mdl"></app-formy> -->
              <app-grid *ngIf="mdl.ctyp=='grid' && mdl.dis==3" [model]="mdl"></app-grid>
              <app-formy *ngIf="mdl.ctyp=='grid' && mdl.disf==3" [model]="mdl"></app-formy>
              <app-chart *ngIf="mdl.ctyp=='chart'" [model]="mdl"></app-chart>
              <app-treev *ngIf="mdl.ctyp=='treev'" [model]="mdl"></app-treev>
            </ng-container>
          </div>
        </div>
      </ng-container>

      <!----- nav display --------------------------->
      <ng-container *ngIf="col[0].dis==4 || col[0].disf==4">
        <nav>
          <div class="nav nav-tabs" id="nav-tab" role="tablist">
            <button *ngFor="let mdl of col; let i=index" class="nav-link{{col[0]==mdl?' active':''}}" id="{{'nav-'+mdl.id+'-tab'}}" data-bs-toggle="tab" [attr.data-bs-target]="'#nav-'+mdl.id" type="button"
              role="tab" [attr.aria-controls]="'nav-'+mdl.id" aria-selected="false">{{mdl.tit}}</button>
          </div>
        </nav>
        <div class="tab-content">
          <div id="{{'nav-'+mdl.id}}" *ngFor="let mdl of col; let i=index" class="tab-pane{{col[0]==mdl?' show active':''}}" role="tabpanel" [attr.aria-labelledby]="'nav-'+mdl.id+'-tab'">
            <app-chtm *ngIf="mdl.ctyp=='chtm'" [model]="mdl"></app-chtm>
            <app-grid *ngIf="mdl.ctyp=='grid' && mdl.dis==4" [model]="mdl"></app-grid>
            <app-formy *ngIf="mdl.ctyp=='grid' && mdl.disf==4" [model]="mdl"></app-formy>
            <app-chart *ngIf="mdl.ctyp=='chart'" [model]="mdl"></app-chart>
            <app-treev *ngIf="mdl.ctyp=='treev'" [model]="mdl"></app-treev>
          </div>
        </div>
      </ng-container>
    </div>
  </div>
</ng-container>

<app-cmodal></app-cmodal>